import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { ProductType } from '../../types';
import { getHandleConnectorForDoor } from '../../utils/handlePlacement';
import { PlannerEcsSystem } from './System';
export class HandlePlacementSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'HandlePlacementSystem', ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
    }
    onAdd(entity) {
        this.placeHandles(entity);
    }
    onUpdate() { }
    onRemove() { }
    placeHandles(entity) {
        const affectsHandlePositon = entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID) ||
            entity.hasComponent(ComponentIds.DOOR_COMPONENT_ID);
        if (!affectsHandlePositon) {
            return;
        }
        const doorFronts = HierarchyUtils.descendants(entity).filter((entity) => entity.hasComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID));
        doorFronts.forEach((front) => {
            const handle = this.coreApi.entities.findChildWithOneOfProductTypes(front, [
                ProductType.HANDLE,
                ProductType.EDGE_HANDLE,
                ProductType.KNOB
            ]);
            if (!handle) {
                return;
            }
            const doorConnectorToUse = getHandleConnectorForDoor(front, handle);
            if (!doorConnectorToUse) {
                return;
            }
            const currentDoorConnector = handle.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)?.highestPriorityConnection?.hostConnector;
            if (currentDoorConnector?.key !== doorConnectorToUse.key) {
                // Resnap handle to front. HandlePlacementValidation will take care of snapping it to correct position.
                this.coreApi.placementService.snapToTarget(handle, front);
            }
        });
    }
}
//# sourceMappingURL=HandlePlacementSystem.js.map